import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { HeaderAsignacionProps } from "src/utils/interfaces";

const HeaderAsignacion: React.FC<HeaderAsignacionProps> = (
  props: HeaderAsignacionProps
) => {
  const botonIzq = props.botonIzq ? (
    <IonButton routerLink={props.botonIzq.url} onClick={props.botonIzq.action}>
      <IonIcon
        slot="icon-only"
        icon={props.botonIzq.icono}
        src={props.botonIzq.src}
      ></IonIcon>
    </IonButton>
  ) : (
    <IonMenuButton />
  );

  let botonesDerecha;
  if (props.botonesDerecha) {
    botonesDerecha = props.botonesDerecha.map((boton, idx) => (
      <IonButton key={idx} routerLink={boton.url} onClick={boton.action}>
        <IonIcon slot="icon-only" icon={boton.icono} src={boton.src}></IonIcon>
      </IonButton>
    ));
  } else botonesDerecha = "";

  return (
    <IonHeader>
      <div className="container px-0">
        <IonToolbar color="primary">
          <IonButtons slot="start">{botonIzq}</IonButtons>

          <IonTitle style={{display:'flex' }}>
                <div>
                  <h4>{sessionStorage['ps_nombre']}</h4>
                  
                  Hrs Asignadas: {sessionStorage['total_asignado']}
                </div>
              
                <div>
                  
                  <p>Legajo: {sessionStorage['legajo']}</p>
                  <p style={{fontSize: '17px'}}>{sessionStorage['op']}</p>
                </div>
              </IonTitle >
              

          <IonButtons slot="end">{botonesDerecha}</IonButtons>
        </IonToolbar>
      </div>
    </IonHeader>
  );
};

export default HeaderAsignacion;
